export default {
  locale: "es",
  name: "Ventana de Cierre de Reserva",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      { fieldName: "startDate", displayName: "Fecha inicio" },
      { fieldName: "endDate", displayName: "Fecha fin" },
      { fieldName: "weekDays", displayName: "Días de la semana" },
      { fieldName: "hourRange", displayName: "Rango de horas" },
      { fieldName: "timeZone", displayName: "Huso horario" },
    ],
    form: [
      {
        fieldName: "restrictions",
        widget: "closeBooking",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Introducir fecha",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        className: "tickerInput",
      },
    ],
  },
};
